import { render, staticRenderFns } from "./summary-dimension-selector.vue?vue&type=template&id=85bde00e&scoped=true"
import script from "./summary-dimension-selector.vue?vue&type=script&setup=true&lang=js"
export * from "./summary-dimension-selector.vue?vue&type=script&setup=true&lang=js"
import style0 from "./summary-dimension-selector.vue?vue&type=style&index=0&id=85bde00e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85bde00e",
  null
  
)

export default component.exports